import React, { useEffect, useState } from "react";


import SpaceParticles from "../../utils/SpaceParticles";
import Header from "../layouts/Header/Header";
import Map from "../../Map";

const Nodes = () => {
  return (
    <div className="hero heros dvpn nodes" style={{ height: "auto" }}>
      <div class="night"  >
        <SpaceParticles />
      </div>
      <div className=" position-relative  px-3 py-3 px-xxl-4 py-xxl-4">
        <Header />
        <div className="container mt-5 mb-5">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <img
                className="w-100"
                src="/assets/images/Cosmicnodes.png"
                alt="Cosmicnodes"
              />
            </div>
            <div className="col-lg-6">
              <h1>
                COSMIC <br />
                <span className="gradient-text">nodes</span> <br />
              </h1>
              <p>
                Cosmic runs on a decentralized network of Nodes. Install our PC
                package to operate a Node and earn passive income through our
                rewards program.
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 mb-4">
              <div className="stats">
                <p>Live Nodes</p>
                <h3>4870</h3>
              </div>
            </div>
            <div className="col-lg-6 mb-4">
              <div className="stats">
                <p>Unique Users</p>
                <h3>4883</h3>
              </div>
            </div>
          </div>
          <div className="row mb-5">
            <div className="col-lg-4 mb-4">
              <div className="stats">
                <p>Total Downloads</p>
                <h3>4870</h3>
              </div>
            </div>
            <div className="col-lg-4 mb-4">
              <div className="stats">
                <p>Total Sessions</p>
                <h3>4883</h3>
              </div>
            </div>{" "}
            <div className="col-lg-4 mb-4">
              <div className="stats">
                <p>Unique Users</p>
                <h3>4883</h3>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div className="spacing">
        <h4 className="text-center mb-5 position-relative">Hosted Nodes</h4>
        {/* <Map/> */}
        <img className="w-100 position-relative" src="/assets/images/map.png" alt="map" />
      </div>
    </div>
  );
};

export default Nodes;
